<template>
   <div class="promotion_coupon_redemption">
      <div class="filter">
         <Form 
            class_binding="row justify-content-md-center" 
            :ref="Model.forms.filter_coupons.name" 
            :forms="Model.forms.filter_coupons.forms" 
            :form_data="Model.forms.filter_coupons.data"
            @button-click="filterCoupons({ref: $refs[Model.forms.filter_coupons.name], id: $route.params.id})"
         />
      </div>
      
      <div class="dotted-border" v-if="promotion__redemptions.length === 0">
         <div class="row justify-content-md-center">
            <div class="col-12 col-md-11 col-lg-10 col-xl-9 action-card">
               <div class="btn btn-transparent btn-primary btn-round"><div :class="Model.tables.promotion_coupon_redemption.props.icon"></div></div>
               <div class="title">{{Model.tables.promotion_coupon_redemption.props.title}}</div>
               <div class="subtitle">
                  No Coupons found! Query to Continue.
               </div>
            </div>
         </div>
      </div>
      
      <Table v-bind="Model.tables.promotion_coupon_redemption.props" :data="promotion__redemptions" @on-action="handleActions" v-if="promotion__redemptions.length > 0">
         <template slot-scope="{ row }" slot="redemption_code">
            <strong class="tx-small" v-if="row.redemption_code">{{ row.redemption_code }}</strong>
            <strong class="tx-small" v-else>-</strong>
         </template>
         <template slot-scope="{ row }" slot="redeemed_at">
            <strong class="tx-small">{{ dayjs(row.redeemed_at).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="discount">
            <strong class="t5">{{utils.numberWithCommas(row.discount)}}</strong>
         </template>
      </Table>
   </div>
</template>

<script>
import promotion_coupon_redemption from "./promotion_coupon_redemption.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('promotion_coupon_redemption')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('promotion_coupon_redemption',promotion_coupon_redemption,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   data (){
      return {
         dayjs,
         utils,
      };
   },
   computed: {
      ...mapGetters([
         'Model',
         'promotion__redemptions',
         'show_create_modal',
         'show_edit_modal',
         'show_delete_modal',
         'loading',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'filterCoupons',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('promotion_coupon_redemption',promotion_coupon_redemption,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .promotion_coupon_redemption{
      
   }
</style>